import { format } from "date-fns";

export interface daysMonth {
  isSelected: boolean;
  isWeekSelected: boolean;
  number?: number;
  week?: string;
  date?: Date;
  day?: string;
  isCurrent?: boolean;
  isPast?: boolean;
  isDisabled: boolean;
}

export const today = new Date();
export const todayMonthIndex = format(today, "M");

export const months = {
  jan: { name: "January", index: 1 },
  feb: { name: "February", index: 2 },
  mar: { name: "March", index: 3 },
  apr: { name: "April", index: 4 },
  may: { name: "May", index: 5 },
  jun: { name: "June", index: 6 },
  jul: { name: "July", index: 7 },
  aug: { name: "August", index: 8 },
  sep: { name: "September", index: 9 },
  oct: { name: "October", index: 10 },
  nov: { name: "November", index: 11 },
  dec: { name: "December", index: 12 },
};

export const weekDays = {
  Mo: { shortName: "M", index: 1 },
  Tu: { shortName: "T", index: 2 },
  We: { shortName: "W", index: 3 },
  Th: { shortName: "T", index: 4 },
  Fr: { shortName: "F", index: 5 },
  Sa: { shortName: "S", index: 6 },
  Su: { shortName: "S", index: 7 },
};

export interface CalendarProps {
  selected?: string[];
  initialMonth?: string;
  onApply(selected: daysMonth[]): void;
  disablePast?: boolean;
  disableWeekend?: boolean;
  multiWeekSelection?: boolean;
  isContainerMoved?: boolean;
  wrapperRef?: React.LegacyRef<HTMLDivElement>;
  selectRef?: React.Ref<HTMLInputElement>;
}
